<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改用户信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="userInfo" :rules="rules" style="display: inline;">
      <FormItem prop="name">
        <label style="display: inline-block; width: 60px;">用户名</label>
        <Input style="display: inline-block; width: 200px;" :disabled="true" v-model="userInfo.name"
               placeholder="请输入用户名">
        </Input>
      </FormItem>
      <FormItem prop="nickName">
        <label style="display: inline-block; width: 60px;">昵称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="userInfo.nickName"
               placeholder="请输入昵称">
        </Input>
      </FormItem>
      <FormItem prop="realName">
        <label style="display: inline-block; width: 60px;">真实姓名</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="userInfo.realName"
               placeholder="请输入真实姓名">
        </Input>
      </FormItem>
      <FormItem prop="sex">
        <label style="display: inline-block; width: 60px;">性别</label>
        <Select style="display: inline-block; width: 200px;" :disabled="!modify" v-model="userInfo.sex">
          <Option v-for="item in userSex" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="mobilePhoneNum">
        <label style="display: inline-block; width: 60px;">手机号码</label>
        <Input style="display: inline-block; width: 200px;" :disabled="true" v-model="userInfo.mobilePhoneNum"
               placeholder="请输入手机号码">
        </Input>
      </FormItem>
      <FormItem prop="introduction">
        <label style="display: inline-block; width: 60px;">简介</label>
        <Input style="display: inline-block; width: 400px;" :disabled="!modify" type="textarea"
               v-model="userInfo.introduction" placeholder="请输入简介">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'UserDetailModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            {required: true, message: '用户名不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    data() {
      return {
        modify: false,
        userSex: [
          {label: '女', value: 0},
          {label: '男', value: 1},
          {label: '未知', value: 2},
        ],
        userInfo: {
          id:null,
          name: null,
          nickName: null,
          realName: null,
          sex: 2,
          mobilePhoneNum: null,
          introduction: null
        }
      }
    },
    methods: {
      ...mapActions([
        'UserServ_GetDetail',
        'UserServ_ModifyObj'
      ]),
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认修改用户信息',
            content: '<p>确认修改用户信息</p>',
            onOk: () => {
              store.dispatch('UserServ_ModifyObj', {
                params: this.userInfo
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              });
            },
            onCancel: () => {
              let userId = this._initValue
              store.dispatch('UserServ_GetDetail', {
                params: {id: userId}
              }).then(() => {
                this.userInfo = store.getters.get_User_GetDetailResult;
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          });
        }
      },
      visibleChange(val) {
        if (val) {
          this.id = null
          this.userInfo.name = null
          this.userInfo.nickName = null
          this.userInfo.realName = null
          this.userInfo.sex = 2
          this.userInfo.mobilePhoneNum = null
          this.userInfo.introduction = null
          let userId = this._initValue
          if (userId) {
            store.dispatch('UserServ_GetDetail', {
              params: {id: userId}
            }).then(() => {
              this.userInfo = store.getters.get_User_GetDetailResult;
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules() {
        return {
          name: this.nameRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
